import React from 'react';
import { Loader2 } from 'lucide-react';

export const Loader = ({ label = 'Loading...' }) => (
  <div className="flex items-center justify-center py-20 text-slate-500">
    <Loader2 className="h-5 w-5 animate-spin mr-2 text-brand" />
    <span className="text-sm">{label}</span>
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    {Icon && (
      <div className="rounded-2xl bg-gradient-to-br from-slate-50 to-slate-100 ring-1 ring-slate-200/70 p-3.5 mb-3">
        <Icon className="h-6 w-6 text-slate-400" />
      </div>
    )}
    <div className="text-sm font-semibold text-ink-900">{title}</div>
    {description && <div className="mt-1 text-sm text-slate-500 max-w-md">{description}</div>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
